module.exports = __webpack_public_path__ + "media/images/advisor/img_4_3-407cda83d5d5500fb8c175decaa9668a.png";